module.exports = __webpack_public_path__ + "static/media/about-small-placeholder.0474d38e.webp";